import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { CustomDialog, Loading, showToast } from "..";
import { piecesService } from "../../services";
import { typologiepieceOptions } from "../../utils/constants";
import { Bâtiment, Espace, Niveau, Site } from "../../interfaces";
import { AutoComplete } from "primereact/autocomplete";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../utils/UserProvider";

interface ModalAddPieceProps {
  modalIsOpenPiece: boolean;
  closeModalPiece: () => void;
  espaces: Espace[];
  sites: Site[];
  batiments: Bâtiment[];
  niveaux: Niveau[];
}
const ModalAddPiece = ({
  espaces,
  modalIsOpenPiece,
  closeModalPiece,
  sites,
  batiments,
  niveaux,
}: ModalAddPieceProps) => {
  const queryClient = useQueryClient();
  const { client } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedespace, setSelectedEsapce] = useState<Espace | null>(null);
  const [filteredEspaces, setFilteredEsapces] = useState<Espace[]>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  watch,
} = useForm();

const reperageAmiante = watch("reperage_amiante");

  const onSubmit = async (data: any) => {
    try {
      if (selectedespace) {
        const pieceData = {
          nom_piece: data.nom_piece,
          typologie_piece: data.typologie_piece,
          espace_id: selectedespace.id,
          env_client_id: client.id,
          nombre:data.nombre,
          reperage_amiante: data.reperage_amiante,
          reperage_plomb: data.reperage_plomb,
          raison_absence_visite_amiante:
            data.reperage_amiante === "non"
              ? data.raison_absence_visite_amiante
              : null,
        };
        setLoading(true);
        await piecesService.post(pieceData).then((response) => {
          setLoading(false);
          showToast("success", "Pièce ajouté avec succès");
          queryClient.refetchQueries({
            queryKey: ["pieces"],
          });
          closeModalPiece();
          // setSelectedEsapce(null);
          reset();
        });
      } else {
        showToast("warning", "Veuillez sélectionner un espace");
      }
    } catch (e) {
      console.log("Error while fetching", e);
      showToast("error", "Error au niveau de l'ajout du pièce dans ESRI");
    }
  };
  const search = (event) => {
    setTimeout(() => {
      let _filteredEspaces;

      if (!event.query.trim().length) {
        _filteredEspaces = [...espaces];
      } else {
        _filteredEspaces = espaces?.filter((espace) => {
          return espace.nom_espace
            .toLowerCase()
            .includes(event.query.toLowerCase());
        });
      }

      setFilteredEsapces(_filteredEspaces);
    }, 250);
  };

  const itemTemplate = (option) => {
    const espace = espaces.find((e) => e.id === option?.id);
    const niveau = niveaux.find((n) => n.id === espace?.niveau_id);
    const bâtiment = batiments.find((b) => b.id === niveau.bâtiment_id);
    const site = sites.find((site) => site.id === bâtiment?.site_id);
    return (
      <div>
        {site ? (
          <span>{`${site?.nom_site} / ${bâtiment?.nom_bâtiment} / ${niveau?.nom_niveau} / ${espace.nom_espace}`}</span>
        ) : (
          <span>{`${bâtiment?.nom_bâtiment} / ${niveau?.nom_niveau} / ${espace.nom_espace}`}</span>
        )}
      </div>
    );
  };

  return (
    <>
      <CustomDialog
        header="Ajouter une pièce"
        visible={modalIsOpenPiece}
        closeModalDialog={() => {
          closeModalPiece();
          // setSelectedEsapce(null);
          reset();
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="relative w-full h-full">
            <div className="p-6 space-y-6">
              <div className="grid grid-cols-6 gap-6">
                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="nom_piece"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Nom *
                  </label>
                  <input
                    type="text"
                    name="nom_piece"
                    id="nom_piece"
                    placeholder="Saisir nom"
                    className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("nom_piece", {
                      required: true,
                      maxLength: 20,
                    })}
                  />
                  {errors.nom_piece && (
                    <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                      champs obligatoire
                    </span>
                  )}
                </div>


                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="nom_niveau"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Nombre *
                  </label>
                  <input
                    type="number"
                    step="1" 
                    min="1"
                    max="10"
                    name="nombre"
                    id="nombre"
                    placeholder="Saisir le Nombre"
                    className="my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("nombre", {
                      required: "Champs obligatoire",
                      min: { value: 1, message: "Le nombre doit être supérieur ou égal à 1" },
                      max: { value: 10, message: "Le nombre doit être inférieur ou égal à 10" },
                      validate: (value) =>
                        /^\d+(\.\d{1,2})?$/.test(value) || "Veuillez entrer un nombre décimal valide",
                    })}
                  />
                  {errors.nombre && (
                    <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                      champs obligatoire
                    </span>
                  )}
                  
                  </div>

                  <div className="col-span-6 sm:col-span-6">
                  <label
                    htmlFor="typologie_piece"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Type *
                  </label>
                  <select
                    id="typologie_piece"
                    name="typologie_piece"
                    className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("typologie_piece", {
                      required: true,
                    })}
                  >
                    {typologiepieceOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>

                  {errors.typologie_piece && (
                    <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                      champs obligatoire
                    </span>
                  )}
                </div>

                
                <div className="col-span-6 sm:col-span-6">
                  <label
                    htmlFor="espace_id"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Choisir espace *
                  </label>

                  <AutoComplete
                    value={selectedespace}
                    suggestions={filteredEspaces}
                    field="nom_espace"
                    completeMethod={search}
                    onChange={(e) => setSelectedEsapce(e.value)}
                    placeholder="Sélectionner un espace"
                    itemTemplate={itemTemplate}
                    className="h-12 my-3 border-gray-300 text-gray-900 font-bold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200  w-full "
                    dropdown
                  />
                </div>

              </div>
              <p className=" text-lg font-thin my-4">* obligatoire</p>

              <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="reperage_amiante"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Repérage amiante *
              </label>
              <select
                id="reperage_amiante"
                name="reperage_amiante"
                className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("reperage_amiante", {
                  required: true,
                })}
              >
                <option value="">Sélectionner</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              {errors.reperage_amiante && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  champs obligatoire
                </span>
              )}
            </div>

            {/* Repérage plomb */}
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="reperage_plomb"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Repérage plomb *
              </label>
              <select
                id="reperage_plomb"
                name="reperage_plomb"
                className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("reperage_plomb", {
                  required: true,
                })}
              >
                <option value="">Sélectionner</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              {errors.reperage_plomb && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  champs obligatoire
                </span>
              )}
            </div>

            {/* Raison absence visite amiante : affiché seulement si repérage amiante = non */}
            {reperageAmiante === "non" && (
              <div className="col-span-6 sm:col-span-6">
                <label
                  htmlFor="raison_absence_visite_amiante"
                  className="block text-md font-bold leading-6 text-gray-900"
                >
                  Raison absence visite amiante *
                </label>
                <input
                  type="text"
                  name="raison_absence_visite_amiante"
                  id="raison_absence_visite_amiante"
                  placeholder="Saisir la raison de l'absence de visite amiante"
                  className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                  {...register("raison_absence_visite_amiante", {
                    required: reperageAmiante === "non",
                  })}
                />
                {errors.raison_absence_visite_amiante && (
                  <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                    champs obligatoire
                  </span>
                )}
              </div>
            )}


              <div className="flex justify-end">
                <button
                  type="submit"
                  className="text-white mt-5  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
                >
                  {loading && (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-4 mr-3 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  )}
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </form>
      </CustomDialog>
      {loading && <Loading />}
    </>
  );
};

export default ModalAddPiece;
